import type { TopLevelDomainOption } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { ITopLevelDomainsFilterDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

export default class FindTopLevelDomainsFilter extends FilterPanelBaseFilter<
    ITopLevelDomainsFilterDto,
    readonly TopLevelDomainOption[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<ITopLevelDomainsFilterDto, readonly TopLevelDomainOption[]>) {
        super(deps);
    }

    calculateValueDelta(
        previousValue?: ITopLevelDomainsFilterDto,
        newValue?: ITopLevelDomainsFilterDto,
    ): FilterValueDelta<string> {
        return calculateArrayDelta(previousValue?.values, newValue?.values);
    }
}
